import { render, staticRenderFns } from "./ListadoAcuerdosClientesTabla.vue?vue&type=template&id=381a88e8"
import script from "./ListadoAcuerdosClientesTabla.vue?vue&type=script&lang=js"
export * from "./ListadoAcuerdosClientesTabla.vue?vue&type=script&lang=js"
import style0 from "./ListadoAcuerdosClientesTabla.vue?vue&type=style&index=0&id=381a88e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports